<template>
  <div>
    <v-card flat>
      <v-card-title> Metrics </v-card-title>
      <v-card-text>
        <div class="d-flex" v-for="metric in metrics" :key="metric.id">
          <div class="flex-grow-1">
            <v-text-field
              v-model="metric.name"
              label="Metric name"
              @input="updateMetricName(metric.id)"
            />
          </div>
          <div class="valueInput">
            <v-text-field
              v-model="metric.valueToAdd"
              append-outer-icon="mdi-plus"
              clear-icon="mdi-close-circle"
              clearable
              label="Enter value or event title"
              @keydown.enter="addValue(metric.id)"
              @click:append-outer="addValue(metric.id)"
              @click:clear="clearValue"
              width="100"
              :ref="metric.id"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-text-field
          v-model="newMetricName"
          append-outer-icon="mdi-plus"
          clear-icon="mdi-close-circle"
          clearable
          label="New metric name"
          @keydown.enter="addMetric"
          @click:append-outer="addMetric"
          @click:clear="clearValue"
          outlined
          hide-details
        ></v-text-field>
      </v-card-actions>
    </v-card>
    <br />
    <v-card>
      <v-card-title> Chart </v-card-title>
      <bart-chart-multiple :metrics="metrics"></bart-chart-multiple>
    </v-card>
    <br />

    <v-card flat>
      <v-card-title>Data</v-card-title>
      <div v-for="metric in metrics" :key="metric.id" class="metricData">
        <div class="d-flex flex-row">
          <div class="flex-grow-1">{{ metric.name }}</div>

          <div>
            <v-dialog v-model="showAddHistoric" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  title="Add a value in the past"
                >
                  <v-icon>mdi-plus </v-icon></v-btn
                >
              </template>

              <v-card>
                <v-card-title class="text-h5">
                  Add value at specified time
                </v-card-title>

                <v-card-text>
                  <input type="datetime-local" v-model="inputDate" />
                  <v-text-field
                    v-model="metric.valueToAdd"
                    append-outer-icon="mdi-plus"
                    clear-icon="mdi-close-circle"
                    clearable
                    label="Enter value or event title"
                    @keydown.enter="addHistoricValue(metric.id)"
                    @click:append-outer="addHistoricValue(metric.id)"
                    @click:clear="clearValue"
                    width="100"
                    :ref="metric.id"
                  />
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="showAddHistoric = false">
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-btn
              @click="downloadObjectAsJson(metric, metric.name)"
              icon
              title="Download data as JSON"
            >
              <v-icon>mdi-code-json </v-icon></v-btn
            >
            <v-btn
              @click="downloadCSVFromArray(metric.data, metric.name)"
              icon
              title="Download data as CSV"
            >
              <v-icon>mdi-file-delimited </v-icon></v-btn
            >

            <v-btn
              @click="deleteMetric(metric.id)"
              icon
              color="red"
              title="Permanently delete metric with its data"
            >
              <v-icon>mdi-delete </v-icon></v-btn
            >
          </div>
        </div>

        <!-- <bart-chart :metric="metric"> </bart-chart> -->

        <v-data-table
          :headers="[
            { text: 'X', value: 'x' },
            { text: 'Y', value: 'y' },
            { text: '', value: 'actions', sortable: false },
          ]"
          :items="metric.data"
          :mobile-breakpoint="0"
          dense
        >
          <template v-slot:item.x="{ item }">
            {{ formatDate(item.x) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small @click="deleteValue(metric.id, item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>

        <!-- <div v-for="value in metric.data" :key="value.x">
        {{ value.y }}
      </div> -->
      </div>
    </v-card>
  </div>
</template>

<script>
  /* eslint-disable */
// import BartChart from "../components/BartChart.vue";
import {
  downloadObjectAsJson,
  downloadCSVFromArray,
} from "../composables/useDownloads";
import BartChartMultiple from "../components/BartChartMultiple.vue";

export default {
  name: "Home",
  data() {
    return {
      userValue: null,
      newMetricName: null,
      showAddHistoric: false,
      inputDate: null,
    };
  },
  computed: {
    metrics() {
      return this.$store.state.metrics;
    },
  },
  components: {
    // BartChart,
    BartChartMultiple,
  },
  methods: {
    addMetric() {
      this.$store.commit("addMetric", { name: this.newMetricName });
    },
    deleteMetric(id) {
      if (confirm("Delete metric and all data associated with it?"))
        this.$store.commit("deleteMetric", { id: id });
    },
    updateMetricName(metricId) {
      this.$store.commit("updateMetricName", {
        id: metricId,
        name: this.metrics[metricId].name,
      });
    },
    addValue(metricId) {
      this.$store.commit("addValue", {
        id: metricId,
        x: new Date(),
        y: this.metrics[metricId].valueToAdd,
      });

      this.metrics[metricId].valueToAdd = null;
      this.$refs[metricId][0].focus();
    },

    addHistoricValue(metricId) {
      let date = new Date(this.inputDate);
      if (date !== new Date("") && this.metrics[metricId].valueToAdd !== null) {
       
        this.$store.commit("addValue", {
          id: metricId,
          x: date,
          y: this.metrics[metricId].valueToAdd,
        });

        this.metrics[metricId].valueToAdd = null;
      }
    },
    deleteValue(metricId, item) {
      if (confirm("Delete value?"))
        this.$store.commit("deleteValue", { metricId, item });
      //const itemIndex = data.indexOf(item);

      // console.log(item);
      // delete item;
    },
    clearValue() {},
    formatDate(date) {
      return date.toLocaleString("nl-NL");
    },
    downloadObjectAsJson,
    downloadCSVFromArray,
  },
};
</script>

<style>
.valueInput {
  width: 50%;
  margin-left: 10px;
}

.metricData {
  padding: 0 16px;
}
</style>
